import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { MDBBtn } from "mdbreact";
import {
  BootstrapTable,
  TableHeaderColumn,
} from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { toast } from "react-toastify";
import { Dialog, Classes, Button, Icon } from "@blueprintjs/core";
import { getTag } from "../utils/getStatus";
import { formatCnpj } from "../../utils";
import { SummaryService } from "../../stores/services/SummaryService";

interface ContestacoesProps { }

interface ContestacoesState {
  date1: string;
  date2: string;
  date: any;
}

@observer
export default class Contestacoes extends React.Component<ContestacoesProps, ContestacoesState> {

  obs = observable({
    tarefas_page: 1 as number,
    detalhes_contestacao: false as boolean,
  })
  
  constructor(props: any) {
    super(props);
  }

  handleBuscaTarefas = async (page: number) => {
    ResultadoStore.handleConsultaTodas(page, 15);
  };

  handleCloseDetalhes() {
    this.obs.detalhes_contestacao = false;
  }

  render() {
    function statusFormatter(cell, row) {

      return getTag(row.status, "contestacao");

    }

    function dateFormatter(cell, row) {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    }

    function stringFormatter(cell, row) {
      return cell.toUpperCase();
    }

    const handleViewDetalhes = async (row) => {
      await SummaryService.summary(
        "resultados_calculos",
        row.contestacao_id,
        row.tipo,
        row.modelo
      );

      if (!ResultadoStore.obs.isValida) {
        let contestacaoId = ResultadoStore.obs.contestacao_summary.import._id;
        await SummaryService.busca_erros_summary("resultados_calculos", contestacaoId);
        this.obs.detalhes_contestacao = true;
      } else {
        toast.warning("Sem dados para mostrar.", {});
      }
    };

    function buttonFormatterDetalhes(cell, row) {
      return (
        <>
          <MDBBtn
            disabled={!row._id}
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleViewDetalhes(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    const renderErroItem = (obj, index) => {
      return (
        <div className="detalheImportItem detalheImportItem--erro" key={index}>
          <Icon icon="error" className="detalheImportItemIcon" />
          <span className="detalheImportItemMsg">{obj.mensagem}</span>
        </div>
      );
    };

    let errosTextValidate = ResultadoStore.obs.erros_contestacao.length;
    let errosText = ResultadoStore.obs.erros_contestacao?.map(renderErroItem);

    function cnpjFormatter(cell, row) {

      if (!cell) return ""

      return formatCnpj(cell)

    }

    return (
      <>
        <Dialog
          isOpen={this.obs.detalhes_contestacao}
          title="Detalhes da Contestação"
          onClose={() => this.handleCloseDetalhes()}
          className="detalhesImportDialog"
        >
          <div className={Classes.DIALOG_BODY}>
            <div className="detalheImportResumo">
              <div className="detalheImportResumoItem">
                <span className="detalheImportResumoNum">{ResultadoStore.obs.contestacao_summary.import.total}</span>
                <span className="detalheImportResumoLabel">Arquivos Processados</span>
              </div>
              <div className="detalheImportResumoItem">
                <span className="detalheImportResumoNum detalheImportResumoNum--ok">{ResultadoStore.obs.contestacao_summary.import.contestados}</span>
                <span className="detalheImportResumoLabel">Arquivo(s) Contestado(s)</span>
              </div>
              <div className="detalheImportResumoItem">
                <span className={ResultadoStore.obs.contestacao_summary.import.erros >= 1
                  ? "detalheImportResumoNum detalheImportResumoNum--erro"
                  : "detalheImportResumoNum"}>{ResultadoStore.obs.contestacao_summary.import.erros}</span>
                <span className="detalheImportResumoLabel">Arquivo(s) com Erro(s)</span>
              </div>
            </div>

            {!errosTextValidate ?
              <div className="detalheImportSucesso">
                <img src="/images/pass_calculo.png" width={44} />
                <h3>Contestação concluída com sucesso</h3>
                <p>Nenhum erro foi encontrado nos arquivos contestados.</p>
              </div>
              :
              <>
                <div className="detalheImportSeg">
                  <button type="button" className="detalheImportSegBtn is-active" style={{ cursor: "default" }}>
                    Erros
                    <span className="detalheImportSegCount detalheImportSegCount--erro">{errosTextValidate}</span>
                  </button>
                </div>

                <div className="detalheImportLista">
                  <div className="detalheImportListaScroll">
                    {errosText}
                  </div>
                </div>
              </>
            }
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.handleCloseDetalhes()} />
            </div>
          </div>
        </Dialog>

        <div data-tut="table">
          <BootstrapTable
            className="TableDefault"
            ref="table"
            data={ResultadoStore.obs.tasks_contestacao}
            data-tut="table"
          >
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">
              {" "}
              #{" "}
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="15%">Empresa</TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={dateFormatter}
              dataField="inserted_at"
              width="20%"
            >
              Data
            </TableHeaderColumn>
            <TableHeaderColumn dataField="motivo" width="40%">
              Motivo
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={stringFormatter}
              dataField="tipo"
              width="10%"
            >
              Tipo
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={stringFormatter}
              dataField="modelo"
              width="10%"
            >
              Modelo
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={statusFormatter} width="30%">
              Status
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">
              Detalhes
            </TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.tarefas_page}
            totalCount={ResultadoStore.obs.length_tasks_contestacao}
            pageSize={15}
            onPageChange={(page) =>
              this.handleBuscaTarefas((this.obs.tarefas_page = page))
            }
          />
        </div>
      </>
    );
  }
}
